import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSocket } from "../../context/SocketContext";

/**
 * Final screen. The wish itself is sent when the visitor confirms
 * RELEASE MY WISH (see AvatarChoiceScreen); here we only wait for the big
 * screen to finish ("free") or time out, then go back home.
 */
const MagicScreen = () => {
  const [, setLatestStatus] = useState("");

  const navigate = useNavigate();
  const { socket } = useSocket();

  useEffect(() => {
    if (!socket) return;

    const handleStatusUpdate = (update: { status?: string }) => {
      if (!update?.status) return;
      setLatestStatus(update.status);
      if (update.status === "free") {
        setTimeout(() => {
          setLatestStatus((current) => {
            if (current === "free") navigate("/");
            return current;
          });
        }, 2000);
      }
    };

    socket.on("makeAWishStatusUpdate", handleStatusUpdate);
    return () => {
      socket.off("makeAWishStatusUpdate", handleStatusUpdate);
    };
  }, [socket, navigate]);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 12000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <section className="magicScreen">
      <h1 className="magicScreen__title">
        SEE THE MAGIC
        <br />
        COME TO LIFE ON
        <br />
        THE BIG SCREEN!
      </h1>
    </section>
  );
};

export default MagicScreen;
